var map = {
	"./v1.png": "157a",
	"./v10.png": "a1fe",
	"./v2.png": "f17c",
	"./v3.png": "533b",
	"./v4.png": "a3ac",
	"./v5.png": "cb30",
	"./v6.png": "3a33",
	"./v7.png": "6ff2",
	"./v8.png": "45fb",
	"./v9.png": "b81d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b59";